import { HttpContext, HttpContextToken } from '@angular/common/http'

export const SPINNER_ENABLED = new HttpContextToken<boolean>(() => true)

export function withSpinner(context?: HttpContext): HttpContext {
    return (context ?? new HttpContext()).set(SPINNER_ENABLED, true)
}
